import React from 'react'
import { useInView } from 'react-intersection-observer'

const featuresItems = [
	{
		image: 'square.gif',
		title: 'TOGETHER IS BETTER',
		description: `We believe games are better when shared. This isn't just about winning; it's about the moments you create. Squad up with friends, challenge others, and form bonds with new teammates in battles that bring people closer.`,
	},
	{
		image: 'prefire.gif',
		title: 'BUILD YOUR LEGACY',
		description:
			'Every match is a step forward. By playing your earn points that can be spent to shape your base into something that reflects your journey. Unlocking new weapons, tools, and strategies that redefine how you play.',
	},
	{
		image: 'knife_fight.gif',
		title: 'FUN, YOUR WAY',
		description:
			'Whether you want to play alone in hordes mode or a little more casually with friends on detonation, this game fits you. Find joy in every firefight, experiment with your approach, and embrace the thrill of a game built for everyone.',
	},
]

function Features() {
	const { ref: h2Ref, inView: h2InView } = useInView({
		triggerOnce: true,
		threshold: 0.5,
	})

	return (
		<div className="text-white bg-fixed bg-cover bg-center py-16 z-10">
			<h2
				ref={h2Ref}
				className={`text-6xl font-bold text-center mb-16 tiny5 ${
					h2InView ? 'animate-title' : 'opacity-0 visibility-hidden'
				}`}
			>
				GAME PILLARS
			</h2>
			<div className="max-w-5xl mx-auto space-y-16">
				{featuresItems.map((item, index) => {
					// eslint-disable-next-line react-hooks/rules-of-hooks
					const { ref, inView } = useInView({
						triggerOnce: true, // Trigger animation once when the element comes into view
						threshold: 0.2, // Trigger when 50% of the element is in view
					})

					return (
						<div
							key={index}
							ref={ref}
							className={`flex flex-col-reverse sm:flex-row items-center ${
								inView
									? index % 2 === 0
										? 'animate-from-left sm:flex-row'
										: 'animate-from-right sm:flex-row-reverse'
									: 'opacity-0 visibility-hidden' // Initially hide the element
							} gap-6 mb-32 sm:mb-12 transition-all duration-500`}
						>
							{/* Image Section */}
							<div className="w-full sm:w-1/2 flex justify-center">
								<img
									src={item.image}
									alt={item.title}
									className="rounded-lg w-full max-w-sm sm:max-w-md"
								/>
							</div>
							{/* Text Section */}
							<div className="w-full sm:w-1/2 text-center sm:text-left px-4">
								<h3 className="text-4xl font-semibold tiny5">
									{item.title}
								</h3>
								<p className="text-md text-justify mt-4 font-sans">
									{item.description}
								</p>
							</div>
						</div>
					)
				})}
			</div>
		</div>
	)
}

export default Features
